import { render } from "./AccountsReceivablePayable.vue?vue&type=template&id=527d5821&scoped=true"
import script from "./AccountsReceivablePayable.vue?vue&type=script&lang=js"
export * from "./AccountsReceivablePayable.vue?vue&type=script&lang=js"

import "./AccountsReceivablePayable.vue?vue&type=style&index=0&id=527d5821&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527d5821"]])

export default __exports__